export default __webpack_public_path__ + "static/media/video2.b2f9587e.mp4";